"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
// A temporary value used to identify if the loop should be broken.
// See #1064, #1293
const breakLoop = {};
exports.default = breakLoop;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./~/async/internal/breakLoop.js
// module id = aWET
// module chunks = 0